import AboutSection from "../components/home/AboutSection";
import CrisisSection from "../components/home/CrisisSection";
import HeroSection from "../components/home/HeroSection";
import NewsSection from "../components/home/NewsSection";
import PartnersSection from "../components/home/PartnersSection";
import ReportsSection from "../components/home/ReportsSection";

/**
 * Главная — только композиция секций. Логика загрузки данных живёт
 * внутри секций, а не в теле страницы.
 */
export function HomePage() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <NewsSection />
      <ReportsSection />
      <CrisisSection />
      <PartnersSection />
    </>
  );
}

export default HomePage;
